import { SelectOption } from './types'

export const PRODUCT_TYPES: SelectOption[] = [
  { label: 'CRM', value: 'crm' },
  { label: 'CMS', value: 'cms' },
  { label: 'Email', value: 'email' },
  { label: 'Data', value: 'data' },
  { label: 'Other', value: 'other' },
]

export const PREDEFINED_TASKS: SelectOption[] = [
  { label: 'Project Management', value: 'project-management' },
  { label: 'Review', value: 'review' },
  { label: 'Daily Call', value: 'daily-call' },
  { label: 'Testing', value: 'testing' },
  { label: 'Concept Work', value: 'concept-work' },
  { label: 'Development', value: 'development' },
  { label: 'Documentation', value: 'documentation' },
]

export const WORK_DURATION_CONSTRAINTS = {
  MIN: 0.5,
  MAX: 24,
  INCREMENT: 0.5,
} as const

export const MAX_PREDEFINED_TASKS = 5
export const DESCRIPTION_MAX_LENGTH = 128
export const INTERNAL_NOTE_MAX_LENGTH = 256
